module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"load_profile_from_fits":"Load Profile from Fits"},"ja":{"load_profile_from_fits":"プロファイルをFITSから読み込み"}}')
  delete Component.options._Ctor
}
